import { DrawCabinet } from "$src/CGS/domain/dto/article/Cabinet/DrawCabinet";
import { DrawFrontDoor } from "$src/CGS/domain/dto/article/Cabinet/FrontElement/DrawFrontDoor";
import { EFrontElement } from "$src/CGS/domain/dto/core/EFrontElement";
import LengthValue from "$src/CGS/domain/dto/core/Length/LengthValue";
import { FrontElementMetadata } from "../Metadata/FrontMetadata";
import { ICabinetShapeGeneratorParameters } from "../ShapeGenerators/ICabinetShapeGeneratorParameters";
import { FixedPanelGenerator } from "./FixedPanelGenerator";
import { FrontShapeGeneratorFactory } from "./FrontShapeGenerators/FrontShapeGeneratorFactory";
import { IFrontElementGenerator } from "./IFrontElementGenerator";

export class FrontElementGeneratorFactory {
    
    static getGenerator(
        frontElementMetadata: FrontElementMetadata,
        doorThickness: LengthValue,
        parameters: ICabinetShapeGeneratorParameters,
        drawCabinet: DrawCabinet
    ): IFrontElementGenerator | null {

        switch (frontElementMetadata.Type) {
            case EFrontElement.D:
                let frontElementGenerator: IFrontElementGenerator | null = null;
                let context = frontElementMetadata.Context;
                if (context instanceof DrawFrontDoor && context.glassDoor !== null) {
                    frontElementGenerator = FrontShapeGeneratorFactory.getGenerator(frontElementMetadata, context.glassDoor, doorThickness);
                }
                if (frontElementGenerator !== null) {
                    return frontElementGenerator;
                } else {
                    // Fall through
                }
            case EFrontElement.PO:
            case EFrontElement.DR:
            case EFrontElement.P:
                // const doorType = parameters?.getFrontDoorColor()?.DoorFrontType ?? "Default";
                // switch (doorType) {
                //     case EDoorFrontType.Default:
                        return new FixedPanelGenerator(frontElementMetadata, doorThickness, parameters);
                //     case EDoorFrontType.GrooveLook_FullFront:
                //         if (frontElementMetadata.Type === "P")
                //             return new FixedPanelGenerator(frontElementMetadata, doorThickness, parameters);
                //         else
                //             return new FrontGrooveLookGenerator(frontElementMetadata, doorThickness, parameters, drawCabinet, "FullDoor");
                //     case EDoorFrontType.GrooveLook_FrontAndGroove:
                //         if (frontElementMetadata.Type === "P")
                //             return new FixedPanelGenerator(frontElementMetadata, doorThickness, parameters);
                //         else
                //             return new FrontGrooveLookGenerator(frontElementMetadata, doorThickness, parameters, drawCabinet, "DoorAndGroove");
                //     // Add other cases as needed
                //     default:
                //         return new FixedPanelGenerator(frontElementMetadata, doorThickness, parameters);
                // }
            // case EFrontElement.F:
            //     return new FrameGenerator(frontElementMetadata, doorThickness);
            // case EFrontElement.G:
            //     return new HorizontalGrooveGenerator(frontElementMetadata);
            // case EFrontElement.SH:
            //     return new ShutterGenerator(frontElementMetadata, doorThickness);
            default:
                return null;
        }
    }
}
